import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';

type Props = {
  isCardDetailsOpen: boolean;
  setIsCardDetailsOpen: (boolean) => void;
}

const SolutionCardToggleCollapseDetails: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    isCardDetailsOpen,
    setIsCardDetailsOpen,
  }: Props = props;

  return (
    <Row
      className={'toggle-collapse-row'}
      css={css`
        margin-right: 0;

        @keyframes fadeIn {
          0% {
            opacity: 0;
            transform: translateY(-10px)
          }
          20% {
            opacity: 1;
          }
          80% {
            opacity: 1;
          }
          100% {
            transform: translateY(0px);
            opacity: 0;
          }
        }

        .description-arrow {
          animation-duration: 1s;
          animation-name: fadeIn;
        }
      `}
    >
      <Col
        xs={{ offset: 6 }}
        css={{
          position: 'relative',
          top: '-20px',
          marginBottom: '25px',
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
        <div
          role="button"
          className={'description-arrow-container'}
          css={{
            position: 'absolute',
            cursor: 'pointer',
          }}
          onClick={(): void => {
            setIsCardDetailsOpen(!isCardDetailsOpen);
          }}
          onKeyPress={(): void => {
            setIsCardDetailsOpen(!isCardDetailsOpen);
          }}
        >
          <svg height={'40px'} width={'40px'}>
            <circle
              cx="20"
              cy="20"
              r="20"
              css={{
                fill: 'white',
                position: 'absolute',
              }}
            />
          </svg>
          <FontAwesomeIcon
            className={'description-arrow'}
            icon={isCardDetailsOpen ? 'angle-up' : 'angle-down'}
          />
        </div>
      </Col>
    </Row>
  );
};

export default SolutionCardToggleCollapseDetails;
